module.exports = __webpack_public_path__ + "img/baner1.e001a727.png";